import React, { Fragment } from 'react'
import {Marker , Tooltip,Popup} from 'react-leaflet';
import {VenueLocationIcon} from './VenueLocationIcon';
import { VenueLocationIconMap } from './VenueLocationIconMap';
import { highlightLocationIconMap } from './highlightLocationIconMap';
import {highlightLocationIcon} from './highlightLocationIcon';
import { useState } from "react";
// import "./Modal/Modal.css";
// import Modal from 'react-bootstrap/Modal'
import 'bootstrap/dist/css/bootstrap.min.css'; 
import SoilMoistureChart from './SoilMoistureChart';
import Draggable from 'react-draggable';

import   {useEffect } from "react";
import axios from 'axios';
import './styleSoilPopup.css';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { useSelector } from 'react-redux';
import 'mdbreact/dist/css/mdb.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import { 

    Modal, 

    ModalHeader, ModalBody 

} from "reactstrap";



const VenueMarkers = (props) => {
  const [coord, setPosition] = useState([]);
  const[modal, setModal] = React.useState(false);
  const[tow_id, settowId] = React.useState('');
  const[instname,setInstName] = React.useState(null);
  const[cropsown , setCrop] = React.useState(null);
  const[idn,setIdn] = React.useState(1);
  const[s, setStyle] = useState(null);
  const [sm15 , setSm15] = useState(null);
  const [sm30,setSm30] = useState(null);
  const [sm45,setSm45] = useState(null);
  const [sm60,setSm60] = useState(null);
  const [sm75,setSm75] = useState(null);
  const [sm90,setSm90] = useState(null);
  const [timestamp  ,setTimestamp] = useState(null);
  const [day,setDay] = useState(null);

  const { venues } = props;
  const { layer } = props;

const intervalRef = React.useRef(null);



const checkVenue = (props) =>
  {
    console.log(props);
    for(var i = 0;i<venues.length;i++)
    {
      if(venues[i].name == props)
      {
        setPosition([venues[i].geometry[0] , venues[i].geometry[1]]);
        setInstName(venues[i].description);
        setCrop(venues[i].crop);
        break;
      }
    
    }
  };



  const handleClose = () =>
  {
    console.log(layer);
    setModal(!modal);
    setPosition([]);
    setIdn(idn+1);
    clearInterval(intervalRef.current);
    
  }

      const handleToggle = ev => {
      
        try{
          if(ev.target.options.name) {
            
            for(var i = 0;i<venues.length;i++)
            {
              if(venues[i].name == ev.target.options.name)
              {
                setIdn(idn+1);
                settowId(venues[i].name);
                setInstName(venues[i].description);
                setPosition([venues[i].geometry[0] , venues[i].geometry[1]]);
                setCrop(venues[i].crop);
                setModal(!modal);
                break;
              }
            
            }          
          }
    }
    catch(error)
    {} 
    
      
  
    };
 
    useEffect( () => {
      
      if(tow_id)
      {
      // axios.get('https://bhuvan.nrsc.gov.in/2dresources/nhp_flux/nhp_api.php?tower_id='+tow_id).then((response) => {
      axios.get('https://bhuvan.nrsc.gov.in/nhpds/fetch-nhp-soil/'+tow_id).then((response) => {
          //console.log(Object.keys(response.data[0]).length);
          console.log();
        if(response.data.length > 0)
        {
          setSm15(response.data[0].soil_vwc_15);
          setSm30(response.data[0].soil_vwc_30);
          setSm45(response.data[0].soil_vwc_45);
          setSm60(response.data[0].soil_vwc_60);
          setSm75(response.data[0].soil_vwc_75);
          setSm90(response.data[0].soil_vwc_90);
          setTimestamp(response.data[0].rest);
          setDay(response.data[0].date);
        }

      });
     
     clearInterval(intervalRef.current);
     intervalRef.current = setInterval( () => {axios.get('https://bhuvan.nrsc.gov.in/nhpds/fetch-nhp-soil/'+tow_id).then((response) => {
          setSm15(response.data[0].soil_vwc_15);
          setSm30(response.data[0].soil_vwc_30);
          setSm45(response.data[0].soil_vwc_45);
          setSm60(response.data[0].soil_vwc_60);
          setSm75(response.data[0].soil_vwc_75);
          setSm90(response.data[0].soil_vwc_90);
          setTimestamp(response.data[0].rest);
          setDay(response.data[0].date);
        

     })} , 180000);
    
     
    }}, [tow_id]);

  const markers = venues.map((venue, index) => ( <>
    <Marker interactive={true} key={index} position={venue.geometry} description = {venue.description} name={venue.name} icon={layer === 'Map' ? VenueLocationIconMap : VenueLocationIcon} onClick={handleToggle} >
    
    
      {/* <MarkerPopup data={venue}/> */}
      {/* <PolygonWithText text="MyText" coords={venue.geometry} /> */}
        {/* <button className="btn-modal" onClick={toggleModal}>Click Here</button> */}
       <Tooltip  interactive={true}  direction="right" shadowSize="[0,0]" border="6px solid transparent"offset={[0, 0]} opacity={1} onClick={handleToggle} permanent >{venue.place}</Tooltip>
    </Marker>
    
    
     </>
  )); 
  
  // high = (coord.map((pos, idx) => (
  //   <Marker
  //     key={`marker-${idx}`}
  //     position={pos}
      
  //   >
      
  //   </Marker>
  // ))
  // );
  const modalStyles = {
    position: "fixed" ,
    top: "50%" ,
    left: "50%" ,
    transform: "translate(-50%, -50%) !important"
};

const class1 = window.innerWidth < 1200 ? 'd-flex align-items-end flex-column bd-highlight mb-3' : 'd-flex justify-content-between';

const class2 = window.innerWidth < 1200 ? 'd-flex align-items-end flex-column bd-highlight mb-3' : 'd-flex justify-content-center"';
  return( 
    <>
    
      <Fragment>{markers}</Fragment>

      {(coord.length != 0) ? 
     <Fragment><Marker
     key={`marker-1`}
     position={coord}
     icon = {highlightLocationIcon}
     
   >
     
   </Marker></Fragment>  : null


     } 
    {/* <div style={{ 

display: 'block', padding: 5

}}>  */}

<Draggable key={idn}>
<Modal className = "modal-soil" 
        show={true}
        size="lg" 
        //style={{marginTop:'10px' , maxWidth: '1000px', width: '90vw'}}
        isOpen={modal} scrollable={true} toggle={handleToggle}
        id="my-modal-test"

        >

    <ModalHeader 
        style = {{backgroundColor: '#255A5E'}}
        toggle={handleClose}><span class = "whiteTextBold">Tower details for: {instname}</span></ModalHeader> 

    <ModalBody id = "modalContentSoil"  size="lg"
        show={true}>
        {/* <div class="background"> */}
          <div className="d-flex justify-content-center">
    <select class="btn " type="button" value={tow_id} id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
      onChange={(event) => { setStyle("custommodal"); settowId(event.target.value); checkVenue(event.target.value); }}>
  <option value="PAU1">PAU, Ludhiana</option>
  <option value="PNR1">GBPUAT, Pantnagar</option>
  <option value="RPR1">IGKV, Raipur</option>
  <option value="PUN1">VSI, Pune</option>
  <option value="HYD">PJTSAU, Hyderabad</option>
  <option value="DWD1">UAS, Dharwad (Tower 1)</option>
  <option value="DWD2">UAS, Dharwad (Tower 2)</option>
  <option value="TDM1">TNAU, Tindivanam (Tower 1)</option>
  <option value="TDM2">TNAU, Tindivanam (Tower 2)</option>
  <option value="SHD">NRSC, Shadnagar</option>
  
  </select>
  </div>

          <MDBTable className = "text-nowrap table-sm  table table-bordered" autoWidth striped style ={{border: '1px solid black'}}>
          
      <MDBTableBody>
        <tr>
          <td class = "blackTextBold" style={{backgroundColor: 'rgb(192,192,192)'}}>Institute Name </td>
          <td class = "blackTextBold">{instname}</td>
        </tr>
        <tr>
          <td class = "blackTextBold" style={{backgroundColor: 'rgb(192,192,192)'}}>SM Sensor </td>
          <td class = "blackTextBold">Gro-Point Profile Soil Moisture Sensor</td>
        </tr>
        <tr>
          <td class = "blackTextBold" style={{backgroundColor: 'rgb(192,192,192)'}}>Crop Sown</td>
          <td class = "blackTextBold">{cropsown}</td>
        </tr>
        <tr>
          <td class = "blackTextBold" style={{backgroundColor: 'rgb(192,192,192)'}}>Units</td>
          <td class = "blackTextBold">Volumetric Moisture Content</td>
        </tr>
      </MDBTableBody>
    </MDBTable>

    <br/>
    <div class="d-flex " style = {{justifyContent : "space-between"}}>
       <div>
        <SoilMoistureChart tower_id={tow_id}></SoilMoistureChart>
      </div>
    <div id = 'table' class="d-flex flex-column bd-highlight mb-3">
      <div class="mt-auto p-2 bd-highlight">
    <MDBTable className = "text-nowrap table-sm  table table-bordered" autoWidth striped style={{backgroundColor: 'rgba(79, 121, 66,0.7)'}}>
      <MDBTableHead>
        <tr>
          <th class = "yellowTextBold">S.No.</th>
          <th class = "yellowTextBold">Depth</th>
          <th class = "yellowTextBold">Percentage</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
        <td class="redTextBold">1</td>
          <td class="whiteTextBold">0 - 15 cm</td>
          <td class = "whiteTextBold"><span>{sm15}</span><span> %</span></td>
        </tr>
        <tr>
          <td class="redTextBold">2</td>
          <td class="whiteTextBold">16 - 30 cm</td>
          <td class = "whiteTextBold"><span>{sm30}</span><span> %</span></td>        
        </tr>
        <tr>
          <td class="redTextBold">3</td>
          <td class="whiteTextBold">31 - 45 cm</td>
          <td class = "whiteTextBold"><span>{sm45}</span><span> %</span></td>        
        </tr>
        <tr>
          <td class="redTextBold">4</td>
          <td class="whiteTextBold">46 - 60 cm</td>
          <td class = "whiteTextBold"><span>{sm60}</span><span> %</span></td>        
        </tr>
        <tr>
          <td class="redTextBold">5</td>
          <td class="whiteTextBold">61 - 75 cm</td>
          <td class = "whiteTextBold"><span>{sm75}</span><span> %</span></td> 
        </tr>
        <tr>
          <td class="redTextBold">6</td>
          <td class="whiteTextBold">76 - 90 cm</td>
          <td class = "whiteTextBold"><span>{sm90}</span><span> %</span></td>
        </tr>
   
      </MDBTableBody>
    </MDBTable>
    </div>
    <div><p class = 'whiteTextBold'>Measured on : {day} {timestamp}</p></div>
    </div>
    </div>
    {/* </div> */}
    </ModalBody>

</Modal> 
{/* <FlexboxPage /> */}
</Draggable>

{/* </div >  */}
    </>);
};

export default VenueMarkers;
